import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

import useQueryMatch from 'hooks/useQueryMatch';
import { AccountSettingsSectionEnum } from '../enums';
import NotificationSettingsPage from './NotificationSettingsPage';
import SecurityPage from './SecurityPage';
import BasePageLabel from 'components/wrappers/BasePageLabel';
import { useAppSelector } from 'hooks/useAppSelector';
import { isAdminSelector } from 'redux/selectors/authenticationSelectors';

const getPageSections = (isAdmin?: boolean) => {
  return isAdmin
    ? [AccountSettingsSectionEnum.Security]
    : Object.values(AccountSettingsSectionEnum);
};

export default function AccountSettingsPage() {
  const navigate = useNavigate();
  const isAdmin = useAppSelector(isAdminSelector);
  const location = useLocation();
  const sectionQuery = queryString.parse(location.search);
  const pageSectionMatch = useQueryMatch(getPageSections(isAdmin));

  const DEFAULT_SECTION = isAdmin
    ? AccountSettingsSectionEnum.Security
    : AccountSettingsSectionEnum.Notification;

  useEffect(() => {
    if (!pageSectionMatch) {
      navigate(`${location.pathname}?section=${DEFAULT_SECTION}`, {
        replace: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSectionMatch]);

  const getAccountSettingsSection = () => {
    switch (sectionQuery.section) {
      case AccountSettingsSectionEnum.Notification:
        return <NotificationSettingsPage />;
      case AccountSettingsSectionEnum.Security:
        return <SecurityPage />;
    }
  };

  return (
    <div className="page-wrapper scroll-box">
      <div className="page-holder">
        <BasePageLabel label="Account settings" />
        <div className="page-box page-inner">
          <div className="page-inner-container">
            {getAccountSettingsSection()}
          </div>
        </div>
      </div>
    </div>
  );
}
